import { types, actions } from './requests'
export const GETUSER_TYPES = {
    ...types('GETUSER'),
}
export const GETUSER_ACTIONS = {
    ...actions('GETUSER'),
}
